import axios from "axios";
import React, { useEffect, useState } from "react";
import Encabezado from "./Encabezado";
import { useParams } from "react-router-dom";
import Titulo4SeccionA from "../Autoevaluacion/Titulo4SeccionA";
import Titulo51SeccionA from "../Autoevaluacion/Titulo51SeccionA";
import Titulo52SeccionA from "../Autoevaluacion/Titulo52SeccionA";
import Titulo9SeccionA from "../Autoevaluacion/Titulo9SeccionA";
import Titulo10SeccionA from "../Autoevaluacion/Titulo10SeccionA";
import Titulo12SeccionA from "../Autoevaluacion/Titulo12SeccionA";
import Titulo2SeccionC from "../Autoevaluacion/Titulo2SeccionC";
import Titulo21SeccionC from "../Autoevaluacion/Titulo21SeccionC";
import Titulo23SeccionC from "../Autoevaluacion/Titulo23SeccionC";
import Titulo231SeccionC from "../Autoevaluacion/Titulo231SeccionC";
import Titulo24SeccionC from "../Autoevaluacion/Titulo24SeccionC";
import Titulo1SeccionD from "../Autoevaluacion/Titulo1SeccionD";
import Titulo2SeccionF from "../Autoevaluacion/Titulo2SeccionF";
import EquipoAutoevaluacion from "../Autoevaluacion/Equipos/SeccionG/EquipoAutoevaluacion";
import EquipoUrgencias from "../Autoevaluacion/Equipos/SeccionG/EquipoUrgencias";
import EquipoHospitalizacion from "../Autoevaluacion/Equipos/SeccionG/EquipoHospitalizacion";
import EquipoCuidadosIntensivo from "../Autoevaluacion/Equipos/SeccionG/EquipoCuidadosIntensivos";
import EquipoCirugia from "../Autoevaluacion/Equipos/SeccionG/EquipoCirugia";
import EquipoSangre from "../Autoevaluacion/Equipos/SeccionG/EquipoSangre";
import EquipoImagenes from "../Autoevaluacion/Equipos/SeccionG/EquipoImagenes";
import EquipoAmbulatorio from "../Autoevaluacion/Equipos/SeccionG/EquipoAmbulatorio";
import EquipoConsultaExterna from "../Autoevaluacion/Equipos/SeccionG/EquipoConsultaExterna";
import EquipoOncologia from "../Autoevaluacion/Equipos/SeccionG/EquipoOncologia";
import EquipoSaludPublica from "../Autoevaluacion/Equipos/SeccionG/EquipoSaludPublica";
import EquipoTerapias from "../Autoevaluacion/Equipos/SeccionG/EquipoTerapias";
import EquipoRehablitacionCardiaca from "../Autoevaluacion/Equipos/SeccionG/EquipoRehablitacionCardiaca";
import EquipoSaludMental from "../Autoevaluacion/Equipos/SeccionG/EquipoSaludMental";
import EquipoSaludRehabilitacion from "../Autoevaluacion/Equipos/SeccionG/EquipoRehabilitacion";
import EquipoOdontologia from "../Autoevaluacion/Equipos/SeccionG/EquipoOdontologia";
import EquipoOdontologiaEspecializada from "../Autoevaluacion/Equipos/SeccionG/EquipoOdontologiaEspecializada";
import EquipoImagenesTerapeuticas from "../Autoevaluacion/Equipos/SeccionG/EquipoImagenesTerapeuticas";
import EquipoPatologia from "../Autoevaluacion/Equipos/SeccionG/EquipoPatologia";
import EstandarAsistencial from "../Autoevaluacion/Estandar/EstandarAsistencial";
import EquipoCirugiaAmbulatoria from "../Autoevaluacion/Equipos/SeccionG/EquipoCirugiaAmbulatoria";
import EquipoDireccionamiento from "../Autoevaluacion/Equipos/SeccionF/EquipoDireccionamiento";
import EquipoGerencia from "../Autoevaluacion/Equipos/SeccionF/EquipoGerencia";
import EquipoTalentoHumano from "../Autoevaluacion/Equipos/SeccionF/EquipoTalentoHumano";
import EquipoAmbienteFisico from "../Autoevaluacion/Equipos/SeccionF/EquipoAbienteFisico";
import EquipoTecnologia from "../Autoevaluacion/Equipos/SeccionF/EquipoTecnologia";
import EquipoGerenciaInformacion from "../Autoevaluacion/Equipos/SeccionF/EquipoGerenciaInformacion";
import ObtenerAdjuntos from "./ObtenerAdjuntos";
import EquipoRehabilitacion from "../Autoevaluacion/Equipos/SeccionG/EquipoRehabilitacion";
import EquipoHospitalario from "../Autoevaluacion/EquiposSeccionG/EquipoHospitalario";
import Titulo1SeccionG from "../Autoevaluacion/Titulo1SeccionG";

function InformeAuto(props) {
  let { id } = useParams();
  let { idSolicitud } = useParams();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/QSubtituloSolicitud?SolicitudId=" +
        idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/Api/ObtenerInstitucionesPorId?Id=" +
        id,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [lis, setLis] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSolicitudesPorId?Id=" +
        idSolicitud,
    })
      .then((Response) => {
        setLis(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setLis]);

  const [list2, setList2] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/" +
        id,
    })
      .then((response) => {
        setList2(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  let filtro = list2.filter((e) => e.titulo == "1.Modelo de atencion");

  // Renderizar el contenido con saltos de línea
  const renderContentWithLineBreaks = (text) => {
    if (!text) return null; // Verificar si 'text' es null o undefined
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  let filtro1 = list2.filter(
    (e) => e.titulo == "2. Estructura organizacional ",
  );
  let filtro2 = list2.filter((e) => e.titulo == "3. organos de direccion");
  let filtro3 = list2.filter(
    (e) => e.titulo == "4. Conformacion de la alta direccion ",
  );
  let filtro4 = list2.filter(
    (e) => e.titulo == "5.Desarrollo de los ejes de acreditacion ",
  );
  let filtro5 = list2.filter(
    (e) => e.titulo == "5.1.Humanizacion de la atencion",
  );
  let filtro6 = list2.filter((e) => e.titulo == "5.2 Seguridad del paciente");
  let filtro7 = list2.filter((e) => e.titulo == "5.3. Gestion de tecnologia");
  let filtro8 = list2.filter(
    (e) => e.titulo == "5.4. Enfoque y gestion del riesgo",
  );
  let filtro9 = list2.filter(
    (e) => e.titulo == "5.5. Transformacion cultural ",
  );
  let filtro10 = list2.filter((e) => e.titulo == "5.6. Responsabilidad social");
  let filtro11 = list2.filter((e) => e.titulo == "6.Gestion de comites");
  let filtro12 = list2.filter(
    (e) => e.titulo == "7. Convenios docencia-servicio",
  );
  let filtro13 = list2.filter((e) => e.titulo == "8.Investigacion en salud");
  let filtro14 = list2.filter(
    (e) =>
      e.titulo == "9.Prestacion de servicios en modalidad de tercerizacion ",
  );
  let filtro15 = list2.filter((e) => e.titulo == "10. Acuerdos sindicales ");
  let filtro16 = list2.filter((e) => e.titulo == "11. Educacion en salud ");
  let filtro17 = list2.filter((e) => e.titulo == "12. Satisfaccion y quejas ");
  let filtro36 = list2.filter(
    (e) => e.titulo == "13. Retos y mejoras organizacionales",
  );

  let filtro18 = list2.filter((e) => e.titulo == "1.1 URGENCIAS");
  let filtro19 = list2.filter((e) => e.titulo == "1.2 HOSPITALIZACION GENERAL");
  let filtro20 = list2.filter((e) => e.titulo == "1.3 GINECOBSTETRICIA");
  let filtro21 = list2.filter((e) => e.titulo == "1.4 CIRUGIA");
  let filtro22 = list2.filter(
    (e) => e.titulo == "1.5 CUIDADOS INTENSIVOS Y CUIDADO INTERMEDIO",
  );

  let filtro23 = list2.filter((e) => e.titulo == "2.1 CONSULTA EXTERNA ");
  let filtro24 = list2.filter((e) => e.titulo == "3. REHABILITACION ");
  let filtro25 = list2.filter((e) => e.titulo == "4. SERVICIOS DE ODONTOLOGiA");
  let filtro26 = list2.filter(
    (e) => e.titulo == "5. IMAGENES DIAGNOSTICAS Y TERAPeUTICAS ",
  );
  let filtro27 = list2.filter(
    (e) => e.titulo == "6. LABORATORIO CLINICO, BANCO DE SANGRE Y PATOLOGIA",
  );
  let filtro28 = list2.filter((e) => e.titulo == "7.SEDES INTEGRADAS");
  let filtro55 = list2.filter(
    (e) => e.titulo == "8.    PROMOCION, PREVENCION Y SALUD PÚBLICA ",
  );

  let filtro29 = list2.filter((e) => e.titulo == "1. Generalidades  ");
  let filtro30 = list2.filter((e) => e.titulo == "2.Infraestructura fisica");
  let filtro31 = list2.filter(
    (e) =>
      e.titulo ==
      "2.2. Planeacion, ejecucion  e impacto de obras de  infraestructura fisica",
  );
  let filtro32 = list2.filter((e) => e.titulo == "2.3. Seguridad ");
  let filtro33 = list2.filter((e) => e.titulo == "2.4. Tecnologia ");

  let filtro34 = list2.filter((e) => e.titulo == "1. Generalidades");

  let filtro35 = list2.filter((e) => e.titulo == "1.Generalidades");
  let filtro37 = list.filter(
    (e) =>
      e.titulo ==
      "Describa de forma concreta y precisa la siguiente informacion",
  );

  let tipoSolicitud = lis.filter((e) => e.tipoSolicitudId == 5);

  return (
    <div>
      <Encabezado />
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION A. INFORMACIÓN GENERAL DE LA INSTITUCIÓN
        </h5>
      </center>
      <div className="text-justify">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>
                <h6 class="m-0 font-weight-bold">Misión</h6>
              </th>
              <br></br>
            </tr>

            {list1.map((item) => {
              return (
                <tr>
                  <td>{renderContentWithLineBreaks(item.mision)}</td>
                </tr>
              );
            })}

            <tr>
              <th>
                <h6 class="m-0 font-weight-bold ">Vision</h6>
              </th>
              <br></br>
            </tr>

            {list1.map((item) => {
              return (
                <tr>
                  <td>{renderContentWithLineBreaks(item.vision)}</td>
                </tr>
              );
            })}
            <tr>
              <th>
                <h6 class="m-0 font-weight-bold">Prinicipios</h6>
              </th>
              <br></br>
            </tr>
            {list1.map((item) => {
              return (
                <tr>
                  <td>{renderContentWithLineBreaks(item.principios)}</td>
                </tr>
              );
            })}
            <tr>
              <th>
                <h6 class="m-0 font-weight-bold">Valores</h6>
              </th>
              <br></br>
            </tr>
            {list1.map((item) => {
              return (
                <tr>
                  <td>{renderContentWithLineBreaks(item.valores)}</td>
                </tr>
              );
            })}
            <tr>
              <th>
                <h6 class="m-0 font-weight-bold">Objetivos Estratégicos.</h6>
              </th>
              <br></br>
            </tr>
            {list1.map((item) => {
              return (
                <tr>
                  <td>
                    {renderContentWithLineBreaks(item.objetivosEstrategicos)}
                  </td>
                </tr>
              );
            })}
            <tr>
              <th>
                <h6 class="m-0 font-weight-bold">
                  Política de Seguridad y salud en el trabajo{" "}
                </h6>
              </th>
              <br></br>
            </tr>
            {list1.map((item) => {
              return (
                <tr>
                  <td>{renderContentWithLineBreaks(item.politicaSeguridad)}</td>
                </tr>
              );
            })}
          </thead>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary text-justify">
          1. Modelo de atención
        </h5>
      </center>
      <div class="table-responsive">
        <div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>SubTitulo</th>
                  <th>Descripción</th>
                  <th>Evidencias</th>
                </tr>
              </thead>
              <tbody>
                {filtro.map((item) => (
                  <tr key={item.subtitulosId}>
                    <td>{item.subtitulos}</td>
                    <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                    <td>
                      <ObtenerAdjuntos
                        idInstitucionId={id}
                        Id={item.subtitulosId}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtro.map((item) => (
            <div key={item.subtitulosId}></div>
          ))}
        </div>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          2.Estructura organizacional
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro1.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          3. Órganos de dirección
        </h5>
      </center>
      <br></br>

      <Titulo4SeccionA idSolicitud={idSolicitud} />
      <br></br>

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          4.Conformación de la alta dirección
        </h5>
      </center>

      <br></br>

      <Titulo51SeccionA idSolicitud={idSolicitud} />
      <Titulo52SeccionA idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro3.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5. Desarrollo de los ejes de acreditacion
        </h5>
      </center>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.1.Humanizacion de la atencion
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro5.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.2 Seguridad del paciente
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro6.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.3. Gestion de tecnologia
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro7.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.4. Enfoque y gestion del riesgo
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro8.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.5. Transformacion cultural
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro9.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5.6. Responsabilidad social
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro10.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">6.Gestion de comites</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro11.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          7. Convenios docencia-servicio
        </h5>
      </center>
      <br></br>

      <Titulo9SeccionA idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro12.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          8.Investigacion en salud
        </h5>
      </center>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro13.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <center>
          <div>
            <h6 class="m-0 font-weight-bold text-primary">
              8.3 Estudios de investigación en salud (incluye los hospitales
              universitarios)
            </h6>
          </div>
        </center>
      </div>
      <Titulo10SeccionA idSolicitud={idSolicitud} />

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          9.Prestacion de servicios en modalidad de tercerizacion
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro14.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          10. Acuerdos sindicales
        </h5>
      </center>
      <br></br>

      <Titulo12SeccionA idSolicitud={idSolicitud} />
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          11. Educacion en salud
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro16.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          12. Satisfaccion y quejas
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro17.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          13. Retos y mejoras organizacionales
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro36.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION B. DESCRIPCIÓN DE LOS SERVICIOS
        </h5>
      </center>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          1. SERVICIOS HOSPITALARIOS
        </h5>

        <h5 class="m-0 font-weight-bold text-primary">1.1 URGENCIAS</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro18.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          1.2 HOSPITALIZACION GENERAL
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro19.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">1.3 GINECOBSTETRICIA</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro20.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">1.4 CIRUGIA</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro21.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          1.5 CUIDADOS INTENSIVOS Y CUIDADO INTERMEDIO
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro22.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          2.SERVICIOS AMBULATORIOS
        </h5>

        <h5 class="m-0 font-weight-bold text-primary">2.1 CONSULTA EXTERNA</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro23.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">3. REHABILITACION</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro24.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          4. SERVICIOS DE ODONTOLOGiA
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro25.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          5. IMAGENES DIAGNOSTICAS Y TERAPEUTICAS
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro26.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          6. LABORATORIO CLINICO, BANCO DE SANGRE Y PATOLOGIA
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro27.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">7.SEDES INTEGRADAS</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro28.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          8. PROMOCION, PREVENCION Y SALUD PÚBLICA{" "}
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro55.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCIÓN C. INFRAESTRUCTURA Y GESTION DE TECNOLOGÍA BIOMÉDICA
        </h5>
      </center>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">1.Generalidades</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro29.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          2.Infraestructura fisica
        </h5>
      </center>
      <br></br>

      <Titulo2SeccionC idSolicitud={idSolicitud} />
      <br></br>

      <Titulo21SeccionC idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro30.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          2.2. Planeacion, ejecucion e impacto de obras de infraestructura
          fisica
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro31.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">2.3. Seguridad</h5>
      </center>
      <br></br>

      <Titulo23SeccionC idSolicitud={idSolicitud} />
      <br></br>

      <Titulo231SeccionC idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro32.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">2.4. Tecnologia</h5>
      </center>
      <br></br>

      <Titulo24SeccionC idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro33.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCIÓN D. DISTRIBUCIÓN Y DESARROLLO DEL TALENTO HUMANO
        </h5>
      </center>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">1. Generalidades</h5>
      </center>
      <br></br>

      <Titulo1SeccionD idSolicitud={idSolicitud} />
      <br></br>

      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro34.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION E. GESTION DE LA INFORMACIÓN
        </h5>
      </center>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">1. Generalidades</h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro35.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulos}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION F. AUTOEVALUACION DE ESTANDARES Y ESTRUCTURA DEL MEJORAMIENTO
        </h5>
      </center>
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          Describa de forma concreta y precisa la siguiente informacion
        </h5>
      </center>
      <div class="table-responsive">
        <table
          class="table table-bordered"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th>SubTitulo</th>
              <th>Descripción</th>
              <th>Evidencias</th>
            </tr>
          </thead>
          <tbody>
            {filtro37.map((item) => {
              return (
                <tr>
                  <td>{item.subtitulo}</td>
                  <td>{renderContentWithLineBreaks(item.descripcion)}</td>
                  <td>
                    <ObtenerAdjuntos
                      idInstitucionId={id}
                      Id={item.subtitulosId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          Describa de forma concreta y precisa la siguiente información:
        </h5>
      </center>
      <Titulo2SeccionF idSolicitud={idSolicitud} />
      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCIÓN G. Equipos y autoevaluación de estándares del proceso de
          atención cliente asistencial
        </h5>
      </center>
      <EquipoAutoevaluacion idSolicitud={idSolicitud} />
      <EquipoUrgencias idSolicitud={idSolicitud} />
      <EquipoHospitalizacion idSolicitud={idSolicitud} />
      <EquipoCuidadosIntensivo idSolicitud={idSolicitud} />
      <EquipoCirugia idSolicitud={idSolicitud} />

      <EquipoAmbulatorio idSolicitud={idSolicitud} />
      <EquipoConsultaExterna idSolicitud={idSolicitud} />
      <EquipoOncologia idSolicitud={idSolicitud} />
      <EquipoSaludPublica idSolicitud={idSolicitud} />
      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          3- EQUIPOS PRIMARIOS DE MEJORAMIENTO DE SERVICIOS DE REHABILITACIÓN
        </h5>
      </center>

      <EquipoRehabilitacion idSolicitud={idSolicitud} />

      <EquipoRehablitacionCardiaca idSolicitud={idSolicitud} />
      <EquipoTerapias idSolicitud={idSolicitud} />
      <EquipoSaludMental idSolicitud={idSolicitud} />

      <EquipoOdontologia idSolicitud={idSolicitud} />
      <EquipoOdontologiaEspecializada idSolicitud={idSolicitud} />

      <EquipoImagenes idSolicitud={idSolicitud} />
      <EquipoImagenesTerapeuticas idSolicitud={idSolicitud} />

      <EquipoSangre idSolicitud={idSolicitud} />

      <EquipoPatologia idSolicitud={idSolicitud} />

      <EquipoCirugiaAmbulatoria idSolicitud={idSolicitud} />

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION H. Autoevaluación de estándares de apoyo
        </h5>
      </center>

      <EquipoDireccionamiento idSolicitud={idSolicitud} />
      <EquipoGerencia idSolicitud={idSolicitud} />
      <EquipoTalentoHumano idSolicitud={idSolicitud} />
      <EquipoAmbienteFisico idSolicitud={idSolicitud} />
      <EquipoTecnologia idSolicitud={idSolicitud} />
      <EquipoGerenciaInformacion idSolicitud={idSolicitud} />

      <br></br>

      <center>
        <h5 class="m-0 font-weight-bold text-primary">
          SECCION I. Autoevaluación de estándares de mejoramiento de la calidad
        </h5>
      </center>
      <p></p>

      {lis.map((item) => {
        return item.tipoSolicitudId == 5 ? (
          <EstandarAsistencial idSolicitud={idSolicitud} />
        ) : (
          item.tipoSolicitudId
        );
      })}
    </div>
  );
}

export default InformeAuto;
